<template>
  <div id="consultationComponent" class="mb-5 pb-5">

    <div class="d-md-flex justify-content-between align-items-center text-center">

      <div class="col-lg-4 p-0">
        <p class="m-0 label d-none d-md-flex">SHOW ME</p>
      </div>

      <div class="col-lg-4 p-0">
        <input v-model="searchTerm" placeholder="Search" type="text" class="mb-5 mb-md-0">
      </div>

      <div class="d-flex justify-content-end sort-wrapper col-lg-4 p-0">
        <p class="mb-0 ml-3 d-none d-md-flex align-items-center label">SORT BY</p>
        <div class="d-flex justify-content-between align-items-center">
          <div @click="openFilter" class="d-md-none">
            <span class="filter">Filter</span>
            <img src="/themes/custom/chorus/images/filter.svg" alt="filter" class="ml-2">
          </div>
          <div :class="['sort-container', {'open': sortOpen}]"
               v-click-away="clickAwayFromSort">
            <span class="current-sort" @click="sortOpen = true">{{ currentSort }}</span>
            <div class="sort-options">
              <div v-for="(item, index) in sortOptions"
                   :key="'sort' + index"
                   :class="{'active': currentSort === item}"
                   @click="applySort(item)">{{ item }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <hr class="mb-4">

    <!-- Previous/next and view toggling -->
    <div class="d-flex col-md-9 ml-md-auto p-0 px-md-3"
         :class="{'justify-content-end': currentViewType === 'Tile view', 'justify-content-between': currentViewType === 'Calendar view'}">
      <div v-if="currentViewType === 'Calendar view'"
           class="month-mover">
        <img src="/themes/custom/chorus/images/arrow-down.svg" alt="previous" class="previous" @click="goToPreviousMonth">
        <img src="/themes/custom/chorus/images/arrow-down.svg" alt="next" class="next" @click="goToNextMonth">
        <p>{{ currentMonth }}</p>
      </div>
      <ul v-if="calendarViewEnabled" class="view-type-options">
        <li v-for="(viewType, index) in viewTypes"
            :key="'viewType' + index"
            class="option pointer"
            :class="{active: currentViewType === viewType}"
            @click="changeView(viewType)">{{ viewTypeLabel(viewType) }}</li>
      </ul>
    </div>

    <div class="d-md-flex">
      <!-- Filters -->
      <div v-if="categoryFilters || typeFilters || archiveFilters"
           :class="['col-md-3 pl-md-0 custom-checkbox-ticks filter-wrapper pb-5 pr-md-5', {open: filterOpen}]">

        <!-- Date -->
        <div class="picker-wrapper" :class="{'has-date': chosenMonthOrDateRange && currentViewType === 'Tile view'}">
          <h5>Dates</h5>
          <input id="datePickerInput"
                 v-model="chosenMonthOrDateRange"
                 placeholder="Select date(s)"
                 name="datePickerInput">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2C8.55228 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V4H18.5C19.8807 4 21 5.11929 21 6.5V19.5C21 20.8807 19.8807 22 18.5 22H5.5C4.11929 22 3 20.8807 3 19.5V6.5C3 5.11929 4.11929 4 5.5 4H7V3C7 2.44772 7.44772 2 8 2ZM16 6H8H5.5C5.22386 6 5 6.22386 5 6.5V9H19V6.5C19 6.22386 18.7761 6 18.5 6H16ZM5 11V19.5C5 19.7761 5.22386 20 5.5 20H18.5C18.7761 20 19 19.7761 19 19.5V11H5Z" fill="#A7336F"/>
          </svg>
        </div>
        <p v-if="chosenMonthOrDateRange && currentViewType === 'Tile view'" @click="clearDate" class="clear-date">Clear date</p>

        <div class="d-flex d-md-none justify-content-between my-4">
          <span class="mobile-filter-heading">Filter</span>
          <span class="clear" @click="clearFilter">Clear all</span>
        </div>
        <div v-if="categoryFilters.children" class="filter-group">
          <h5>{{ categoryFilters.title }}</h5>
          <div v-for="(childTerm, index) in categoryFilters.children"
               :key="'childTerm' + index"
               class="child-term child">
            <input :id="'childTerm' + childTerm.id"
                   type="checkbox"
                   :value="childTerm.id"
                   v-model="checkedCategories"
                   class="form-check-input">
            <label :for="'childTerm' + childTerm.id">
              {{ childTerm.title }}
            </label>
          </div>
        </div>
        <div v-if="typeFilters.children" class="filter-group">
          <h5>{{ typeFilters.title }}</h5>
          <div v-for="(childTerm, index) in typeFilters.children"
               :key="'childTerm' + index"
               class="child-term child">
            <input :id="'childTerm' + childTerm.id"
                   type="checkbox"
                   :value="childTerm.id"
                   v-model="checkedTypes"
                   class="form-check-input">
            <label :for="'childTerm' + childTerm.id">
              {{ childTerm.title }}
            </label>
          </div>
        </div>
        <div v-if="archiveFilters.children" class="filter-group">
          <h5>{{ archiveFilters.title }}</h5>
          <div v-for="(childTerm, index) in archiveFilters.children"
               :key="'childTerm' + index"
               class="child-term child">
            <input :id="'childTerm' + childTerm.id"
                   type="checkbox"
                   :value="childTerm.id"
                   v-model="checkedArchives"
                   class="form-check-input">
            <label :for="'childTerm' + childTerm.id">
              {{ childTerm.title }}
            </label>
          </div>
        </div>
        <button class="btn btn-primary d-md-none" @click.prevent="closeFilter">Apply</button>
      </div>

      <!-- Main content - tiles or calendar -->
      <div class="col-md-9 d-md-flex flex-wrap align-self-baseline p-0">

        <!-- Tile view -->
        <template v-if="currentViewType === 'Tile view'">
          <!-- No cards message -->
          <template v-if="!this.processedCards.length">
            <div class="chorus-cards-placeholder pt-4 pl-3">
              Sorry, we don't have anything to show at the moment. Please check back soon.
            </div>
          </template>
          <div class="chorus-cards">
            <div :key="item.nid" v-for="item in processedCards" class="chorus-image-tiles card">
              <a :href="item.link" class="h-100">
                <!-- Image and optional category -->
                <div v-show="item.image" :class="['card-image', !item.image ? 'gradient-gray' : '']">
                  <div class="card-image__image">
                    <img :src="item.image" :alt="item.title">
                  </div>
                  <div class="card-image__category" v-if="item.type"
                       :style="{'background-color': item.typeBackground}">{{ item.type }}
                  </div>
                </div>
                <div class="card-image-content">
                  <div>
                    <!-- Pretext -->
                    <p v-if="item.pretext" class="pretext mb-2 pt-1" v-html="item.pretext"/>
                    <!-- Title -->
                    <h5 class="card-title">{{ item.title }}</h5>
                    <!-- Copy -->
                    <p v-if="item.blurb" class="m-0">{{ item.blurb }}</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </template>

        <!-- Calendar view -->
        <template v-else>
          <template v-if="calendarViewEnabled">
            <FullCalendar ref="fullCalendar" :options="calendarOptions" />
          </template>
        </template>

      </div>
    </div>
  </div>
</template>

<script type="ts">
import { directive } from "vue3-click-away";
import flatpickr from "flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import 'flatpickr/dist/plugins/monthSelect/style.css'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import moment from 'moment'
import he from 'he'

export default {
  name: 'ConsultationComponent',
  components: {
    FullCalendar
  },
  directives: {
    ClickAway: directive
  },
  data: function() {
    return {
      cards: JSON.parse(he.decode(window.consultationCards)),
      categoryFilters: JSON.parse(he.decode(window.categoryFilters)),
      typeFilters: JSON.parse(he.decode(window.typeFilters)),
      archiveFilters: JSON.parse(he.decode(window.archiveFilters)),
      calendarOptions: {
        height: 910,
        plugins: [ dayGridPlugin ],
        initialView: 'dayGridMonth',
        events: [] // Empty to start with because directly passing events in any way did not render anything
      },
      sortOpen: false,
      filterOpen: false,
      calendar: null,
      currentMonth: new Date().toLocaleString('default', {month: 'long'}),
      chosenMonthOrDateRange: null,
      checkedCategories: [],
      checkedTypes: [],
      checkedArchives: [],
      searchTerm: '',
      filterDateStart: '',
      filterDateEnd: '',
      currentViewType: 'Tile view',
      viewTypes: ['Tile view', 'Calendar view'],
      currentSort: window.defaultSortOption,
      sortOptions: [window.defaultSortOption, 'Alphabetical'],
      tileViewCalendarConfig: {
        disableMobile: 'true',
        altInput: true,
        mode: 'range',
        dateFormat: 'd/m/Y',
        altFormat: 'd/m/y',
        enableTime: false,
        noCalendar: false,
      },
      calendarViewCalendarConfig: {
        disableMobile: 'true',
        altInput: true,
        dateFormat: 'Z',
        enableTime: false,
        noCalendar: false,
        plugins: [
          monthSelectPlugin({
            dateFormat: 'm Y'
          })
        ]
      },
    }
  },
  watch: {
    chosenMonthOrDateRange: function (value) {
      if (value) {
        // Check if there are two dates - true only when the user has chosen a range in the tile view
        const dateRange = value.split(' to ')
        if (dateRange && dateRange.length === 2) {

          // Get the individual start and end date/month/year so we can put it into the data object in correct order
          const [startDay, startMonth, startYear] = dateRange[0].split('/');
          const [endDay, endMonth, endYear] = dateRange[1].split('/');

          // Date objects for start/end, including seconds (minus one month due to month indexing starting from 0)
          const startDate = new Date(startYear, (startMonth - 1), startDay, 0, 0, 0)
          const endDate = new Date(endYear, (endMonth - 1), endDay, 23, 59, 59)

          this.filterDateStart = startDate.getTime() / 1000 // Divide by 1000 to get seconds instead of milliseconds
          this.filterDateEnd = endDate.getTime() / 1000 // Divide by 1000 to get seconds instead of milliseconds

        } else {
          // Only a single date has been chosen, so use this for the start and end dates
          const [day, month, year] = value.split('/');
          const date = new Date(year, (month - 1), day, 0, 0, 0)
          this.filterDateStart = date.getTime() / 1000 // Divide by 1000 to get seconds instead of milliseconds
          this.filterDateEnd = date.getTime() / 1000 // Divide by 1000 to get seconds instead of milliseconds
        }
      }
    },
    processedCards: function () {
      this.calendarOptions.events = this.calendarEvents
    },
  },
  computed: {
    calendarViewEnabled() {
      return window.location.pathname === '/consultations'
    },
    calendarEvents() {
      // Compile a list of events for use in the calendar, based on the already processed cards
      let events = []
      let cards = this.processedCards
      cards.forEach(card => {
        events.push({
          title: card.title,
          url: card.link,
          color: card.typeBackground,
          start: moment.unix(card.startTime).format('YYYY-MM-DD'),
          end: moment.unix(card.endTime).format('YYYY-MM-DD'),
        })
      })

      return events
    },
    processedCards() {
      let cards = this.cards

      if (!this.checkedArchives.length) {
        // Do not show any archived cards
        cards = cards.filter((item) => {
          return !item.isArchived
        })
      }

      if (this.checkedCategories.length) {
        cards = cards.filter((card) => {
          return this.checkedCategories.some(category => card.categories.indexOf(category) >= 0)
        })
      }

      if (this.checkedTypes.length) {
        cards = cards.filter((card) => {
          return this.checkedTypes.some(category => card.categories.indexOf(category) >= 0)
        })
      }

      if (this.checkedArchives.length) {
        cards = cards.filter((card) => {
          return this.checkedArchives.some(category => card.categories.indexOf(category) >= 0)
        })
      }

      // Filter by search term, if any
      if (this.searchTerm) {
        cards = cards.filter((card) => {
          return card.title.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
      }

      if (this.filterDateStart && this.filterDateEnd) {
        cards = cards.filter((item) => {
          if (this.filterDateStart === this.filterDateEnd) {
            // If the filter start and end date are the same then only one date was chosen
            // Check if the date is between the start and end date
            return this.filterDateStart >= item.startTime && this.filterDateEnd <= item.endTime
          } else {
            // Only return items that start OR end between the chosen dates
            return (item.startTime >= this.filterDateStart && item.startTime <= this.filterDateEnd) ||
              (item.endTime >= this.filterDateStart && item.endTime <= this.filterDateEnd)
          }
        })
      }

      // Already sorted by PHP (see IndustryEngagementController.php)
      // ... but conditionally sort alphabetically if the user chooses
      if (this.currentSort === 'Alphabetical') {
        cards = this.sortAlphabetically(cards)
      }

      return cards
    }
  },
  mounted () {
    this.calendar = flatpickr('#datePickerInput', this.tileViewCalendarConfig)
    this.calendarOptions.events = this.calendarEvents
  },
  methods: {
    viewTypeLabel(viewType) {
      let label = viewType
      if (window.innerWidth < 768) {
        label = label.replace(' view', '');
      }

      return label
    },
    openFilter() {
      this.filterOpen = true
      document.body.classList.add('modal-open')
    },
    goToPreviousMonth() {
      const calendar = this.$refs.fullCalendar.getApi()
      calendar.prev();
      this.currentMonth = moment(calendar.getDate()).format('MMMM')
    },
    goToNextMonth() {
      const calendar = this.$refs.fullCalendar.getApi()
      calendar.next();
      this.currentMonth = moment(calendar.getDate()).format('MMMM')
    },
    changeView(viewType) {
      if (this.currentViewType !== viewType) {
        this.currentViewType = viewType
        this.clearDate()
      }
    },
    sortAlphabetically(items) {
      return items.sort((a, b) => {
        let aV = a['title'].trim()
        let bV = b['title'].trim()
        if (aV < bV) {
          return -1;
        }
        if (aV > bV) {
          return 1;
        }
        return 0;
      })
    },
    clearDate() {
      this.calendar.clear()
      this.calendar.destroy()
      this.chosenMonthOrDateRange = null
      this.filterDateStart = ''
      this.filterDateEnd = ''
      this.currentMonth = new Date().toLocaleString('default', {month: 'long'})

      if (this.currentViewType === 'Tile view') {
        this.calendar = flatpickr('#datePickerInput', this.tileViewCalendarConfig)
      } else {
        this.calendar = flatpickr('#datePickerInput', this.calendarViewCalendarConfig)
      }
    },
    clearFilter: function () {
      this.checkedCategories = []
      this.checkedTypes = []
      this.checkedArchives = []
    },
    closeFilter() {
      this.filterOpen = false
      document.body.classList.remove('modal-open')
    },
    clickAwayFromSort() {
      this.sortOpen = false
    },
    applySort: function (item) {
      this.currentSort = item
      this.sortOpen = false
    },
  }
}
</script>

<style lang="scss">
@import '../../src/scss/consultation-flatpickr-and-full-calendar-styles.scss';
</style>
<style lang="scss" scoped>
#consultationComponent {
  margin-top: 30px;

  @media screen and (min-width: 768px) {
    margin-top: 50px;
  }

  .label {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
  }

  input[type=text] {
    width: 100%;
    height: 45px;
    border-radius: 6px;
    border: 1px solid #ACACAC;
    padding: 0 40px 0 10px;
    background: url(~@/assets/search.svg) no-repeat 95% 8px;

    &:focus {
      outline: 0;
    }

    @media screen and (min-width: 992px) {
      width: 389px;
    }
  }

  hr {
    border-color: #A1A1A1;
  }

  // Style the sort drop down options
  .sort-wrapper {
    height: 34px;

    > div {
      width: 100%;
      @media screen and (min-width: 768px) {
        width: auto;
      }
    }

    .label {
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
    }

    .sort-container {
      display: flex;

      .current-sort {
        display: none;

        @media screen and (min-width: 768px) {
          width: 140px;
          padding: 5px 10px 5px 0;
          display: block;
        }
      }

      div.sort-options {
        display: flex;
        border: 1px solid #922367;
        border-radius: 18px;

        @media screen and (min-width: 768px) {
          flex-direction: column;
          border-radius: 0;
          border: 0;
        }

        div {
          border-radius: 18px;
          padding: 3px 15px;
          color: #313131;
          text-align: right;

          &.active {
            background: #922367;
            color: #FFF;
          }

          @media screen and (min-width: 768px) {
            display: none;
            border: 0;
            &.active {
              background: #FFF;
              color: #313131;
            }
          }
        }
      }

      @media screen and (min-width: 768px) {
        background: url(~@/assets/search-down-arrow.svg) no-repeat 94% 13px;
        cursor: pointer;
        position: relative;

        &.open {
          background-image: url(~@/assets/search-up-arrow.svg);

          div.sort-options {
            position: absolute;
            left: -1px;
            width: 142px;
            border: 1px solid #DFE3E4;
            background: white;
            z-index: 1;
            padding: 5px;

            div {
              display: block;
            }
          }
        }
      }
    }

    .filter {
      font-weight: 600;
    }

    .clear {
      text-decoration: underline;
      font-weight: 600;
    }
  }

  // Style the filtering
  .filter-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    z-index: -1;

    &.open {
      width: 100vw;
      height: 100vh;
      z-index: 100;
      background: #FFF;
      padding-left: 15px !important; // Override bootstrap class
      padding-top: 30px;
      overflow: auto;
    }

    @media screen and (min-width: 768px) {
      position: static;
      width: auto;
      height: auto;
      z-index: 0;
    }

    h5 {
      font-size: 14px;
      font-weight: 600;
    }

    .mobile-filter-heading {
      font-weight: 600;
      font-size: 16px;
    }

    .filter-group {
      .child-term:last-child {
        margin-bottom: 24px;
      }

      &:not(:last-child) .child-term:last-child {
        border-bottom: 1px solid #A1A1A1;
        padding-bottom: 16px;
      }
    }

    &.custom-checkbox-ticks {
      input[type=checkbox] {
        position: absolute;
        opacity: 0;
        left: -200px;

        + label {
          position: relative;
          display: block;
          padding: 3px 0 0 35px;
          line-height: 17px;
          font-size: 14px;
          font-weight: 400;

          &:before {
            display: inline-block;
            height: 16px;
            width: 16px;
            position: absolute;
            left: 4px;
            top: 3px;
            content: "";
            border-radius: 2px;
            border: 1.5px solid #922367;
          }
        }

        &:checked + label {
          &:before {
            background-color: #922367;
            border-color: #922367;
          }

          &:after {
            display: inline-block;
            height: 16px;
            width: 16px;
            position: absolute;
            left: 4px;
            top: 3px;
            content: '';
            background-image: url("data:image/svg+xml,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.84619 4.1087L4.71576 7.5L10.9766 1' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
            background-size: 82%;
            background-position: 1px 3px;
            background-repeat: no-repeat;
            border-radius: 2px;
            border-color: #922367;
            color: #FFF;
            font-size: 20px;
          }
        }
      }
    }
  }

  .view-type-options {
    display: inline-flex;
    height: 36px;
    border: 1px solid #922367;
    border-radius: 18px;
    padding: 0;
    margin-bottom: 24px;
    font-size: 14px;

    .option {
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 15px;
      padding-right: 15px;
      color: #313131;

      &.active {
        background: #922367;
        color: #FFF;
      }
    }
  }

  .chorus-cards {
    width: 100%;

    @media (min-width: 768px) {
      margin-left: 0;
      margin-right: 0;
    }

    .card {
      transition: none;
    }

    .card.chorus-image-tiles {
      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
      margin-bottom: 20px;
      overflow: hidden;

      &:hover {
        box-shadow: 0 1px 10px rgba(0, 0, 0, 0.3);

        a {
          text-decoration: none;
        }

        h5 {
          color: #6F224A;
        }

        img {
          transform: scale(1.1);
        }
      }

      @media (min-width: 768px) {
        width: 49%;
        flex: 0 0 49%;
        max-width: 49%;
        min-width: auto;
        margin: 0 0 16px 0;

        &:nth-child(odd) {
          margin-right: 1%;
        }

        &:nth-child(even) {
          margin-left: 1%;
        }
      }

      @media (min-width: 992px) {
        width: 32%;
        flex: 0 0 32%;
        max-width: 32%;

        &:nth-child(odd) {
          margin-right: 0;
        }

        &:nth-child(even) {
          margin-left: 0;
        }

        // Target every 3rd element, starting from the second one
        &:nth-child(3n+2) {
          margin-left: 2%;
          margin-right: 2%;
        }
      }

      img {
        width: 100%;
        border-radius: 4px 4px 0 0;
        transition: all 0.2s ease-in-out;
      }

      .card-image {
        position: relative;

        .card-image__image {
          display: flex;
          min-height: 150px;
          overflow: hidden;

          @media (min-width: 768px) {
            height: 150px;
          }
        }

        .card-image__category {
          position: absolute;
          bottom: -12px;
          left: 16px;
          height: 24px;
          padding: 0 10px;
          background-color: #A7336F;
          font-size: 12px;
          color: #fff;
          font-weight: 500;
          line-height: 24px;
        }
      }

      h5 {
        font-size: 18px;
        line-height: 24px;
        color: #912767;

        // Line clamp to 2 lines with these 4 lines:
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        // End line clamping
      }

      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #313131;

        &.pretext {
          min-height: 24px;
          line-height: 20px;
          color: #838284;
        }
      }

      .card-image-content {
        padding: 16px;
      }
    }
  }

  .picker-wrapper {
    position: relative;
    margin-bottom: 27px;

    &.has-date {
      margin-bottom: 0;
    }

    svg {
      position: absolute;
      right: 17px;
      top: 38px;
      pointer-events: none;
    }
  }

  .clear-date {
    text-decoration: underline;
    font-size: 14px;
    color: #A7336F;
    margin: 10px 0 27px;
    display: block;
    font-weight: 500;
    cursor: pointer;
  }

  .month-mover {
    display: flex;
    margin-bottom: 15px;

    img {
      align-self: center;
      cursor: pointer;

      &.next {
        transform: rotate(-90deg);
      }

      &.previous {
        transform: rotate(90deg);
      }
    }

    p {
      font-size: 18px;
      line-height: 22px;
      margin: 0 0 0 10px;
      font-weight: 600;
      align-self: center;
    }
  }
}
</style>
